mutation DeleteLeadDistributionAutomation(
    $leadDistributionAutomation: DeleteLeadDistributionAutomationInputFieldInput!
) {
    deleteLeadDistributionAutomation(
        input: {leadDistributionAutomation: $leadDistributionAutomation}
    ) {
        leadDistributionAutomation {
            id
        }
    }
}
